import { Grid, makeStyles } from "@material-ui/core";
import useText from "constants/text";
import { checkReccurenceIntervalDate, ITourTemplateAxe } from "contexts/RequestQuoteContext";
import { isSunday } from "date-fns";
import { AddRequestInput, EReccurenceType, ReccurenceOptionsInput } from "generated/graphql";
import React from "react";
import "styled-components/macro";
import Dialog from "ui/Dialog";
import { TextField } from "ui/TextField";
import { ErrorStep } from "../../shared/MainStyles";
import Reccurence from "../../shared/Reccurence";
import { isFieldWithValue, isInCorrectIntervallTime, isSlotIntervallCorrect } from "../../shared/utils";

const useStyles = makeStyles(() => ({
  validate: {
    marginLeft: "auto",
    display: "flex",
    flexDirection: "row-reverse",
    marginTop: "3rem",
  },
}));

interface Props {
  open: boolean;
  templateAxe: ITourTemplateAxe;
  onClose?: (axe: ITourTemplateAxe) => void;
}

export const AxeReccurence = ({ open, templateAxe, onClose }: Props) => {
  const [axeWithRecc, setAxeWithRecc] = React.useState(null);
  const styles = useStyles();
  React.useEffect(() => {
    setAxeWithRecc({ ...axeWithRecc, ...templateAxe });
  }, [templateAxe]);
  const { text } = useText();

  const onReccurenceChange = (reccurenceType: EReccurenceType, options?: ReccurenceOptionsInput) => {
    setAxeWithRecc({ ...axeWithRecc, reccurenceType, reccurenceOptions: options });
  };
  const onChangeDate = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAxeWithRecc({ ...axeWithRecc, [event.target.name]: event.target.value });
  };
  const onChangeTime = (event: React.ChangeEvent<HTMLInputElement>) => {
    const timeHour = event.target.value?.split(":");
    const time = parseInt(timeHour[0], 10);
    if (!Number.isNaN(time))
      setAxeWithRecc({ ...axeWithRecc, [event.target.name]: `${timeHour[0]}:00` });
  };

  const confirm = () => {
    onClose(axeWithRecc);
  };
  const isReccurenceValuesInvalid = React.useMemo(
    () =>
      !isFieldWithValue(axeWithRecc?.reccurenceType) ||
      !isSlotIntervallCorrect(axeWithRecc?.slotStart, axeWithRecc?.slotEnd),
    [axeWithRecc]
  );

  return (
    <Dialog
      handleClose={onClose}
      handleConfirm={confirm}
      open={open}
      title={text.requestQuote.define_reccurency}
      disableConfirmButton={isReccurenceValuesInvalid}
    >
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Reccurence
            reccurence={axeWithRecc as unknown as AddRequestInput}
            onReccurenceChange={onReccurenceChange}
            onchangeEndRequestDate={onChangeDate}
            endRequestDate={axeWithRecc?.endDate}
            startRequestDate={axeWithRecc?.startDate}
            error={!isFieldWithValue(axeWithRecc?.reccurenceType)}
            dateError={!checkReccurenceIntervalDate(axeWithRecc)}
            noEndDate
          />
        </Grid>
        {isSunday(axeWithRecc?.startDate as unknown as Date) && <ErrorStep>{text.all.sunday_error}</ErrorStep>}

        <Grid item xs={6}>
          <TextField
            id="time_from"
            label={text.all.slot_start}
            type="time"
            name="slotStart"
            value={axeWithRecc?.slotStart || ""}
            onChange={onChangeTime}
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
            inputProps={{
              step: 3600,
            }}
            error={
              !isFieldWithValue(axeWithRecc?.slotStart) ||
              !isSlotIntervallCorrect(axeWithRecc?.slotStart, axeWithRecc?.slotEnd)
            }
            helperText={
              !isFieldWithValue(axeWithRecc?.slotStart)
                ? text.all.this_field_is_required
                : !isSlotIntervallCorrect(axeWithRecc?.slotStart, axeWithRecc?.slotEnd)
                ? text.all.intervall_slot_error
                : ""
            }
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            id="time_to"
            label={text.all.slot_end}
            type="time"
            name="slotEnd"
            value={axeWithRecc?.slotEnd || ""}
            onChange={onChangeTime}
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
            inputProps={{
              step: 3600,
              
            }}
            error={
              !isFieldWithValue(axeWithRecc?.slotEnd) ||
              !isSlotIntervallCorrect(axeWithRecc?.slotStart, axeWithRecc?.slotEnd)
            }
            helperText={
              !isFieldWithValue(axeWithRecc?.slotEnd)
                ? text.all.this_field_is_required
                : !isSlotIntervallCorrect(axeWithRecc?.slotStart, axeWithRecc?.slotEnd)
                ? text.all.intervall_slot_error
                : ""
            }
          />
        </Grid>
      </Grid>
    </Dialog>
  );
};
